'use client';
import './tab.scss';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import router from 'next/router';
import { useRef } from 'react';

interface TabProps {
  _id?: string;
  title: string | null;
  slug: { current: string } | null;
}

interface ReusableTabsProps {
  tabs: TabProps[];
  mainURL?: string;
  activeTab?: string;
}
const TabComponent: React.FC<ReusableTabsProps> = ({
  tabs = [],
  mainURL,
  activeTab,
}) => {
  const pathname = usePathname();
  const defaultTab = activeTab && mainURL === pathname;
  const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);

  const handleKeyDown = (
    e: React.KeyboardEvent,
    index: number,
    href: string
  ) => {
    if (e.key === 'ArrowRight') {
      const nextIndex = (index + 1) % tabs.length;
      tabsRef.current[nextIndex]?.focus();
    } else if (e.key === 'ArrowLeft') {
      const prevIndex = (index - 1 + tabs.length) % tabs.length;
      tabsRef.current[prevIndex]?.focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      router.push(href);
    }
  };
  return (
    <ul className="custom-tab" aria-label="Tabs for Categories" role="tab">
      {tabs.map((tab, index) => {
        const href =
          tab.title === 'All'
            ? `${mainURL}`
            : `${mainURL}/category/${tab?.slug?.current}`;
        return (
          <li key={index}>
            <Link
              href={href}
              scroll={false}
              className={`tab-link ${pathname === href || (defaultTab && activeTab === tab.slug?.current) ? 'active' : ''}`}
              role="tab"
              tabIndex={0}
              aria-selected={activeTab === tab.title}
              aria-controls={`panel-${tab.slug?.current || 'all'}`}
              id={`tab-${tab.slug?.current || 'all'}`}
              onKeyDown={(e) => handleKeyDown(e, index, href)}
              aria-label={`${tab.title}`}
            >
              {tab.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
export default TabComponent;
